import PublicHolidayListPagingResultModelBase from '../_generated/modelBases/public-holiday-list-paging-result-model-base';

export default class PublicHolidayListPagingResultModel extends PublicHolidayListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
